export default {
  contracts: {
    activeContracts: '有效服務合同',
    productsAndHours: '涵蓋產品和剩餘保養時間',
    supported: '保養',
    notSupported: '未被保養合同涵蓋',
    contact: '聯絡',
    dividerText: '涵蓋產品及剩餘可用工作時數'
  },
  states: {
    OPEN: '等待跟進',
    AWAITING_REPLY: '等待回覆',
    CLOSED: '完成',
    FEEDBACK_REQUIRED: '等待回饋意見',
    onlyRequired: '僅顯示必需的操作'
  },
  common: {
    New: '新',
    Open: '等待跟進',
    Pending: '等待處理',
    Closed: '完成',
    create: '建立',
    cancel: '取消',
    goBack: '返回',
    close: '完成',
    goToMain: '返回主頁',
    news: '訊息反饋',
    moreInfo: '需提供更多資料',
    change: '更改',
    send: '送出',
    description: '內容描述',
    skip: '略過'
  },
  property: {
    name: '營業場所名稱',
    allProperties: '所有營業場所',
    selectProperty: '請選擇營業場所'
  },
  product: {
    name: '產品',
    allProducts: '所有產品',
    selectProduct: '請選擇產品',
    goBack: '返回',
    noProducts: '沒有適合產品'
  },
  chart: {
    chooseMonth: '選擇月份',
    noData: '所選日期沒有數據'
  },
  navigation: {
    main: '主页',
    interactions: '服務請求',
    contracts: '合同',
    signOut: '登出'
  },
  tickets: {
    createNewTitle: '建立新服務請求',
    title: '標題',
    noTickets: '當前沒有服務請求',
    search: '搜索',
    createNew: '建立',
    reopenOrDisagree: '服務請求重開或不同意',
    escalation: '上報',
    reason: '原因',
    reopen: '重開',
    disagree: '不同意',
    escalate: '上報',
    opinionTitle: '您的意見對我們很重要!',
    opinionBody: '請評價我們的工作人員的表現',
    time: '解決時間',
    qualification: '技術資格',
    communication: '溝通技巧',
    sendFeedback: '發送回饋',
    leaveFeedback: '退出回饋',
    close: '完成',
    alreadyHasFeedback: '服務請求已經有回饋意見',
    feedbackHasBeenSent: '回饋意見已經發送',
    ticketHasBeenReopened: '服務請求己重開',
    ticketHasBeenEscalated: '服務請求己上報',
    comment: '評論',
    keyPlaceholder: '輸入訊息'
  },
  severity: {
    name: '緊急程度',
    0: '一般',
    1: '高',
    2: '緊急',
    wantToChange: '希望更改緊急程度?'
  },
  forms: {
    email: '電郵',
    password: '密碼',
    confirmPassword: '確認密碼',
    passwordsDoNotMatch: '密碼不正確',
    updatePassword: '更新密碼',
    askRestore: '要求更新密碼',
    remember: '記住賬號',
    restorePassword: '恢復密碼',
    signIn: '登入',
    required: '請求己發出',
    invalidEmail: '電郵賬戶不正確'
  },
  transactions: {
    date: '日期',
    type: '類型',
    comment: '評論',
    status: '狀態',
    subject: '工作要求',
    name: '交易清單',
    hours: '小時',
    viewTransactions: '查看紀錄',
    types: {
      WORK_REQUEST: '工作要求',
      CONTRACT_ACTIVATION: '合同激活',
      CONTRACT_EXPIRATION: '合同到期',
      MANUAL_ADJUST_ADD: '手動調整 - 添加',
      MANUAL_ADJUST_DEDUCT: '手動調整 - 扣除',
      TRANSFER_PROPERTY: '營業場所轉移',
      TRANSFER_PRODUCT: '產品轉移'
    }
  },
  transactionDetail: {
    name: '交易明細',
    num: '數字',
    insertTime: '創立日期',
    requestorName: '請求者名稱',
    subject: '主題',
    status: '狀態',
    acceptTime: '接受日期',
    cancelTime: '取消日期',
    hours: '時間',
    hourType: '時間類型',
    workText: '工作描述',
    plannedDate: '暫定日期'
  },
  statuses: {
    Approved: '己批准',
    Pending: '等待中',
    Cancelled: '己取消'
  },
  hoursTypes: {
    'Included in contract': '包含在合同中',
    'Installation hours': '安裝時間',
    'Preventative visit': '阻止拜訪',
    Chargeable: '需要收費'
  },
  errors: {
    unknown: '發生未知錯誤',
    1000: '錯誤 1000',
    1001: '錯誤 1001',
    1: '登錄名稱或密碼錯誤',
    2: '此頁面己過期',
    3: '不明營業場所',
    4: '不明產品',
    7: '不明動作',
    8: '互動動作已經結束',
    11: '接駁訪問衝突',
    12: '不明要求',
    660: '由於本案尚有待處理事項未完成因此未能關閉 我們的技術支援人員會盡快處理你的結案請求  感謝你的等待與體諒',
    fileSize: '不可上存超過20MB的檔案'
  },
  phrases: {
    noAccount: ['還未有登入賬戶?', '請與我們聯繫'],
    dnd: ['將文件拖至此處或瀏覽查詢', '將文件拖至此處或瀏覽查詢', '']
  }
}
